<template>
  <div class="app-container flex-table-container">
    <el-form ref="searchModel" :model="searchModel" label-width="auto" class="table-query-form">
      <el-form-item prop="keyword" label="文件名称">
        <el-input
          v-model="searchModel.keyword"
          placeholder="请输入名称"
          clearable
          @keyup.enter.native="getTableData(true)"
        ></el-input>
      </el-form-item>
      <el-form-item prop="dateRange" label="创建时间">
        <el-date-picker
          v-model="searchModel.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          clearable
          @change="getTableData(true)"
        ></el-date-picker>
      </el-form-item>

      <el-form-item class="form-btn" label-width="0">
        <el-button type="success" @click="getTableData(true)">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="cbox-p14 table-main">
      <TableHeader :refTable="refTable" storageKey="hiddenColumns_qualifications" @onRefresh="getTableData()">
        <el-button v-auth="'qualifications:add'" type="primary" @click="handleAdd">新增</el-button>
      </TableHeader>

      <el-table ref="table" :data="tableData" border stripe height="100%" v-loading="tableLoading">
        <el-table-column label="序号" align="center" width="50" fixed>
          <template v-slot="{ $index }">
            <span>{{ (searchModel.pageNum - 1) * searchModel.pageSize + $index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="fileName" label="文件名称" min-width="180" header-align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="150" align="center"></el-table-column>
        <el-table-column prop="createtime" label="上传时间" width="160" align="center"></el-table-column>
        <el-table-column prop="createByName" label="上传人" width="160" align="center"></el-table-column>

        <el-table-column label="操作" width="140" align="center" fixed="right">
          <template v-slot="{ row }">
            <el-link type="primary" @click="handleDownload(row)">下载文件</el-link>
            <el-link v-auth="'qualifications:delete'" type="danger" @click="handleDelete(row)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page="searchModel.pageNum"
        :page-size="searchModel.pageSize"
        background
        layout="total, prev, sizes ,pager, next, jumper"
        :total="dataTotal"
        @current-change="onCurrentChange"
        @size-change="onSizeChange"
      ></el-pagination>
    </div>

    <ArchivesEdit
      :visible.sync="editVisible"
      :archivesType="this.searchModel.type"
      :activeId="activeRowId"
      @refresh="getTableData()"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import TableHeader from '@/components/TableHeader';
import ArchivesEdit from '../components/ArchivesEdit';

import { getAppFileList, deleteAppFile } from '@/api/archives';

export default {
  components: { TableHeader, ArchivesEdit },
  data() {
    return {
      refTable: null,
      searchModel: {
        pageNum: 1,
        pageSize: 20,
        type: 'file_type_zizhi',
        keyword: '',
        dateRange: []
      },
      dataTotal: 0,
      tableLoading: false,
      tableData: [],
      // 弹窗
      activeRowId: null,
      editVisible: false
    };
  },
  computed: {
    ...mapGetters(['userId'])
  },
  watch: {},
  methods: {
    handleReset() {
      this.$refs.searchModel.resetFields();
      this.getTableData();
    },
    onCurrentChange(pageNum) {
      this.searchModel.pageNum = pageNum;
      this.getTableData();
    },
    onSizeChange(pageSize) {
      this.searchModel.pageNum = 1;
      this.searchModel.pageSize = pageSize;
      this.getTableData(true);
    },
    async getTableData(isFirstPage = false) {
      if (isFirstPage) this.searchModel.pageNum = 1;
      this.tableLoading = true;

      const startDate = this.searchModel?.dateRange?.[0] ?? null;
      const endDate = this.searchModel?.dateRange?.[1] ?? null;
      const startTime = startDate ? startDate + ' 00:00:00' : null;
      const endTime = endDate ? endDate + ' 23:59:59' : null;

      const { data } = await getAppFileList({ ...this.searchModel, startTime, endTime });
      this.dataTotal = data.count;
      this.tableData = data.list || [];
      this.tableLoading = false;
    },
    handleAdd() {
      this.activeRowId = null;
      this.editVisible = true;
    },
    handleEdit(row) {
      this.activeRowId = row.id;
      this.editVisible = true;
    },
    handleDownload(row) {
      if (!row.filePath) return this.$message.warning('暂无对应文件!');
      const timestamp = new Date().getTime();
      const encodedFileUrl = encodeURIComponent(row.filePath);
      const fullUrl = `${process.env.VUE_APP_BASE_API}/${encodedFileUrl}?t=${timestamp}`;

      // 创建一个隐藏的<a>标签
      const link = document.createElement('a');
      link.href = fullUrl;
      link.download = row.fileName || '档案文件'; // 设置下载的文件名
      document.body.appendChild(link);
      link.click(); // 触发点击事件开始下载
      document.body.removeChild(link); // 下载完成后移除<a>标签
    },
    handleDelete(row) {
      this.$confirm('确定删除所选信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          await deleteAppFile({ id: row.id });
          this.$message.success('删除成功');
          this.getTableData();
        })
        .catch(() => {});
    }
  },
  mounted() {
    this.refTable = this.$refs.table;
  },
  activated() {
    this.getTableData();
    this.$nextTick(() => {
      this.$refs.table.doLayout(); // 重置表格布局
    });
  } //页面有keep-alive触发
};
</script>

<style lang="scss" scoped>
::v-deep .el-table {
  .warning-row {
    .el-table__cell {
      position: relative;
    }
  }
  .logo-box {
    padding-left: 12px;

    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 24px;
      height: 24px;
    }
  }
}
</style>
